import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Annotator from 'views/pages/Annotation';
import PatientEnrollment from '../views/pages/PatientEnrollment';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import KardiaRx from '../views/pages/KardiaRx';
import ROUTE_PATHS from './routePaths';
import UserProfileProvider from '../auth/contexts/UserProfileContext';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2d9f86',
    },
    secondary: {
      main: '#895da7',
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: `'proxima-nova', 'Helvetica Neue', helvetica, arial, sans-serif `,
    color: '#000000D9',
  },
});

const routes = [
  {
    exact: true,
    authenticateRoute: true,
    path: ROUTE_PATHS.IDTF_KARDIA_RX,
    component: props => (
      <UserProfileProvider>
        <KardiaRx {...props} />
      </UserProfileProvider>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENT_ENROLLMENT}`,
    component: props => (
      <UserProfileProvider>
        <ThemeProvider theme={theme}>
          <ContentWithNavigationSidebar>
            <PatientEnrollment {...props} />
          </ContentWithNavigationSidebar>
        </ThemeProvider>
      </UserProfileProvider>
    ),
  },
  {
    exact: true,
    authenticateRoute: true,
    // path: `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/:recordingId/:participantId/:templateId`,
    path: `${ROUTE_PATHS.EKG_REVIEW_EKG_ANNOTATION}/:recordingId/:idtf_connection_id`,
    component: props => (
      <UserProfileProvider>
        <ThemeProvider theme={theme}>
          <ContentWithNavigationSidebar>
            <Annotator {...props} />
          </ContentWithNavigationSidebar>
        </ThemeProvider>
      </UserProfileProvider>
    ),
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/idtfRoutes.jsx